/*
 * File: CancelPeriodEnrollment.ts
 * Author: Austin Robinson
 * Date Created: 6/8/2023
 * Copyright (c) DrivingDoc 2023
 */

import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';
import { invalidateQueryKeys } from 'api/hooks/middlewares';

export interface CancelPeriodEnrollmentParams {
  coursePeriodId: string,
  studentId: string,
  cancel: boolean,
  overrideLateFee?: boolean
}

async function cancelPeriodEnrollment(params: CancelPeriodEnrollmentParams | undefined): Promise<object | null> {
  if (params === undefined) {
    return null;
  }

  // make api call
  const result = await privateApi.post(`/courses/periods/cancelEnrollment`, params, {

  });

  // return the data object
  return result?.data;
}

const useCancelPeriodEnrollment = createMutation<object | null, CancelPeriodEnrollmentParams, AxiosError<ErrorResponse>, unknown>({
  mutationFn: async (variables: CancelPeriodEnrollmentParams) => cancelPeriodEnrollment(variables),
  use: [
    invalidateQueryKeys([
      { queryKey: ['self_scheduled_course_period_count'] },
      { queryKey: ['student_course_enrollments'] },
      { queryKey: ['self_scheduled_course_periods'] },
      { queryKey: ['student_course_periods'] },
      { queryKey: ['student_ledger'] },
    ]),
  ],
});

export { useCancelPeriodEnrollment };
